// 安全 localStorage 封装：夸克等浏览器隐私模式下 localStorage 不可用时降级到内存
const memoryStore: Record<string, string> = {};

export function safeSetItem(key: string, val: string) {
  try {
    localStorage.setItem(key, val);
  } catch {
    memoryStore[key] = val;
  }
}

export function safeGetItem(key: string): string | null {
  try {
    return localStorage.getItem(key) || memoryStore[key] || null;
  } catch {
    return memoryStore[key] || null;
  }
}

export function safeRemoveItem(key: string) {
  try {
    localStorage.removeItem(key);
  } catch {
    delete memoryStore[key];
  }
}
